export const environment = {
    production: false,
    apiUrl: 'https://gateway.dev.takenote.cloud/cc',
    productId: 'Eurochange-Demo',
    productType: 'EEN'
};